import { render, staticRenderFns } from "./DamageAssessorCaseInformationCard.vue?vue&type=template&id=09556085&scoped=true"
import script from "./DamageAssessorCaseInformationCard.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseInformationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09556085",
  null
  
)

export default component.exports